import { type VisualizationChartPropsWithLoader } from '../visualization-chart/chart-action/chart-types';

import { type WidgetPropSchema } from './widget-wrapper';

export type StreamableChartWidgetProps = VisualizationChartPropsWithLoader &
	Record<string, unknown>;

export const VISUALIZATION_CHART_PROP_SCHEMA: WidgetPropSchema<StreamableChartWidgetProps> = {
	chartType: 'wait-for-complete',
	data: 'stream-complete-items',
	chartTitle: 'stream-characters',
	subtitle: 'stream-characters',
	xAxisLabel: 'stream-characters',
	yAxisLabel: 'stream-characters',
	numEl: 'wait-for-complete',
	numGroups: 'wait-for-complete',
	yMin: 'wait-for-complete',
	yMax: 'wait-for-complete',
	xAccessor: 'wait-for-complete',
	yAccessor: 'wait-for-complete',
	labelAccessor: 'wait-for-complete',
	valueAccessor: 'wait-for-complete',
	colorAccessor: 'wait-for-complete',
	metricsConfig: 'wait-for-complete',
};
